import API from "../Api";

export const apiValidateCampaignToken = (token) =>
  API.get(`/api/v1/coupon/store-promotion/validate/${token}`);

export const apiRegisterCampaignUsage = (body) =>
  API.post(`/api/v1/coupon/store-promotion/register-usage`, body);

export const apiCheckCampaignUsage = (dni, promotionId) =>
  API.get(`/api/v1/coupon/store-promotion/check-usage/${dni}/${promotionId}`);

export const apiValidateCampaignDocument = (dni) =>
  API.post(`/api/v1/user/is-promotional-user`, { is_promotion_user: true, dni });
